import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudOperationsService {

  private editOperationSource = new Subject<boolean>();
  private cloneOperationSource = new Subject<boolean>();
  private deleteOperationSource = new Subject<boolean>();
  private answerSetOperationSource = new Subject<boolean>();

  editOperation$ = this.editOperationSource.asObservable();
  cloneOperation$ = this.cloneOperationSource.asObservable();
  deleteOperation$ = this.deleteOperationSource.asObservable();
  answerSetOperation$ = this.answerSetOperationSource.asObservable();

  editOperation(params) {
    this.editOperationSource.next(params);
  }

  cloneOperation(params) {
    this.cloneOperationSource.next(params);
  }

  deleteOperation(params) {
    this.deleteOperationSource.next(params);
  }

  answerSetOperation(params) {
    this.answerSetOperationSource.next(params);
  }
}
